import { render, staticRenderFns } from "./btnConfigFields.vue?vue&type=template&id=84e42112"
import script from "./btnConfigFields.vue?vue&type=script&lang=js"
export * from "./btnConfigFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports